module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1102537"
    }
  }, [_c('b', [_vm._v("SALMON PÂTÉ")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1103137"
    }
  }, [_c('b', [_c('i', [_vm._v("This combination of fresh and smoked salmon brings elegance to a Sunday brunch buffet, while the microwave and food processor make preparation easy.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1104437"
    }
  }, [_c('b', [_vm._v("Prep: 10 minutes plus chilling "), _c('br'), _vm._v(" Cook: 2 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1105237"
    }
  }, [_vm._v("1 lemon")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1105537"
    }
  }, [_vm._v("1 piece salmon fillet (8 ounces), skin removed")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1105837"
    }
  }, [_vm._v("¼ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1106737"
    }
  }, [_vm._v("⅛ teaspoon ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1107737"
    }
  }, [_vm._v("2 tablespoons water")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1108037"
    }
  }, [_vm._v("8 ounces smoked salmon")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1108337"
    }
  }, [_vm._v("3 tablespoons butter or margarine, softened")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1108637"
    }
  }, [_vm._v("2 tablespoons reduced-fat cream cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1109037"
    }
  }, [_vm._v("2 tablespoons chopped fresh chives "), _c('br'), _vm._v(" toast rounds or unsalted crackers")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1109837"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" From lemon, grate 1 teaspoon peel. Cut lemon in half. From 1 lemon half, squeeze 1 tablespoon juice; cut other lemon half into 3 slices. Set peel and juice aside.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1111137"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Sprinkle salmon fillet with salt and pepper to season both sides. Place in microwave-safe shallow bowl or glass pie plate. Top salmon with lemon slices and water. Cook, covered, in microwave oven on High 2 minutes. Let stand, covered, 2 minutes longer. Remove salmon from liquid and place in medium bowl; flake with fork and set aside to cool.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1113837"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Meanwhile, in food processor with knife blade attached, pulse smoked salmon, butter, Neufchâtel, and lemon peel and juice just until smooth (do not overprocess). Gently stir smoked salmon mixture and 1 tablespoon chives into flaked salmon in bowl just until combined. Wrap remaining chives in plastic wrap and refrigerate for garnish later. Spoon salmon pâté into serving bowl or crock; cover and refrigerate for at least 2 hours or overnight.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1117137"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" To serve, let pâté stand at room temperature 30 minutes or until soft enough to spread. Garnish pâté with remaining chives. Serve with toast rounds or crackers. Makes about 2 cups.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1119037"
    }
  }, [_vm._v("Each tablespoon: About 30 calories, 3g protein, 0g carbohydrate, 2g total fat (1g saturated), 0g fiber, 6mg cholesterol, 180mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-700edd7f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c24_r1.vue
// module id = 138
// module chunks = 0